// Translations for Equinesport (Danish and English)

export const ROUTE_MAPS = {
  da: {
    home: "/da",
    horses_sales: "/da/heste/salg",
    horses_sport: "/da/heste/sportsheste",
    references: "/da/referencer",
    sponsors: "/da/sponsorer",
    about: "/da/om-os",
    gallery: "/da/galleri",
    contact: "/da/kontakt"
  },
  en: {
    home: "/en",
    horses_sales: "/en/horses/sales",
    horses_sport: "/en/horses/sport-horses",
    references: "/en/references",
    sponsors: "/en/sponsors",
    about: "/en/about-us",
    gallery: "/en/gallery",
    contact: "/en/contact"
  }
};

export const TRANSLATIONS = {
  da: {
    meta: {
      home: {
        title: "Eksklusive Sportsheste | Equinesport Heineking",
        description: "Uddannelse, træning og formidling af eksklusive sportsheste i det absolut højeste internationale prissegment. Etableret i 2012 af Marcus & Rikke Heineking."
      },
      horses_sales: {
        title: "Heste til Salg | Eksklusiv Kollektion | Equinesport",
        description: "Se vores udvalgte kollektion af eksklusive springsheste til salg i det absolutte topsport-segment. Priser omkring 1 mio. euro pr. stk."
      },
      horses_sport: {
        title: "Elite Sportsheste | International Topklasse | Equinesport",
        description: "Udforsk vores elite sportsheste uddannet til højeste internationale niveau. Kompromisløs kvalitet og dokumenterede resultater."
      },
      references: {
        title: "Referencer & Resultater | Equinesport",
        description: "Se vores succesfulde referencer og heste, der præsterer på de største internationale arenaer under verdenseliten."
      },
      sponsors: {
        title: "Sponsorer & Partnere | Equinesport",
        description: "Vores stærke netværk af førende globale brands og partnere inden for ridesporten, der deler vores passion for perfektion."
      },
      about: {
        title: "Om Os | Årtiers Elite Ride-Excellence | Equinesport",
        description: "Lær mere om Equinesport, grundlagt i 2012 af Grand Prix-rytter Marcus Heineking og elitetræner Rikke Heineking."
      },
      gallery: {
        title: "Galleri & Medier | Equinesport",
        description: "Oplev vores heste, træningsfaciliteter og hverdagen hos Equinesport i billeder. Se vores eksklusive mediearkiv."
      },
      contact: {
        title: "Kontakt Os | Indled en Fortrolig Dialog | Equinesport",
        description: "Kontakt Marcus & Rikke Heineking for en fortrolig samtale om køb, salg eller uddannelse af elite sportsheste."
      }
    },
    nav: {
      home: "Forside",
      horses: "Heste",
      horses_sales: "Salg",
      horses_sport: "Sportsheste",
      references: "Referencer",
      sponsors: "Sponsorer",
      about: "Om os",
      gallery: "Galleri",
      contact: "Kontakt"
    },
    home: {
      hero_badge: "Est. 2012",
      hero_title_italic: "",
      hero_title_main: "Equinesport",
      hero_desc: "",
      hero_btn_collection: "Se Kollektionen",
      hero_btn_contact: "Indled Dialog",
      
      about_title: "Uddannelse & individuel træning",
      about_desc: "Hos Equinesport er hver enkelt sportshest et unikat. Siden 2012 har vi specialiseret os i at identificere, uddanne og forædle heste med potentiale til den absolutte topsport. Vores gennemsnitlige prissegment på ca. 1 mio. euro pr. hest afspejler den kompromisløse kvalitet og det minutiøse arbejde, der lægges i hver enkelt detalje.",
      about_btn: "Læs mere om vores filosofi",
      
      focus_badge: "Udforsk Vores Verden",
      focus_title: "Strategiske Fokusområder",
      focus_desc: "Klik på kasserne nedenfor for at dykke dybere ned i vores kernekompetencer og eksklusive ydelser.",
      
      box1_badge: "Eksklusiv Portefølje",
      box1_title: "Kollektion & Salg",
      box1_desc: "Oplev vores nøje udvalgte kollektion af internationale sportsheste i det absolut højeste prissegment.",
      box1_btn: "Se Kollektionen",
      
      box2_badge: "Kompromisløs Forædling",
      box2_title: "Om os",
      box2_desc: "Individuelt tilpassede træningsforløb af hest og rytter med henblik på den absolutte topsport.",
      box2_btn: "Læs Om Træning",
      
      box3_badge: "Dokumenteret Succes",
      box3_title: "Referencer & Resultater",
      box3_desc: "Vores heste præsterer på de største internationale arenaer under ryttere i den absolutte verdenselite.",
      box3_btn: "Et udpluk af solgte heste gennem tiden",
      
      box4_badge: "Stærkt Netværk",
      box4_title: "Sponsorer & Partnere",
      box4_desc: "Et tæt samarbejde med førende globale brands og partnere, der deler vores passion for perfektion.",
      box4_btn: "Se Vores Partnere",
      
      expertise_badge: "Vores Ekspertise",
      expertise_title: "Strategiske Fokusområder",
      
      banner_title: "Investering i Præstation & Genetik",
      banner_desc: "Marcus og Rikke Heineking sikrer gennem personlig selektion og kompromisløs uddannelse, at hver enkelt hest besidder den fornødne kapacitet, forsigtighed og ridelighed til at begå sig på den globale scene.",
      banner_stat1_label: "Individuelt Fokus",
      banner_stat2_label: "Niveau",
      banner_stat3_label: "Etableret",
      invitation_text: "Kig dig gerne omkring på vores hjemmeside, og tøv endelig ikke med at kontakte os!"
    },
    horses: {
      badge: "Kollektion",
      title_sales: "Salg",
      title_sport: "Sportsheste",
      title_suffix: "Collection",
      desc_sales: "Udvalgte heste til salg i det absolutte topsport-segment",
      desc_sport: "Eksklusive sportsheste uddannet til højeste internationale niveau",
      desc_suffix: "Hver hest i vores kollektion er nøje udvalgt, sundhedstestet og uddannet med henblik på optimal præstation og holdbarhed.",
      loading: "Henter heste fra CMS...",
      error: "Der opstod en fejl ved hentning af heste",
      empty: "Ingen heste fundet i denne kategori i øjeblikket.",
      spec_pedigree: "Afstamning",
      spec_gender: "Køn",
      spec_age: "Alder",
      spec_height: "Højde",
      age_suffix: "år",
      btn_inquiry: "Forespørgsel",
      btn_call: "Ring til Marcus"
    },
    references: {
      badge: "Succeshistorier",
      title: "Referencer &",
      title_italic: "historier",
      desc: "Vores største stolthed er de heste, vi har solgt og uddannet, som nu præsterer på højeste internationale plan med deres nye ryttere over hele verden.",
      loading: "Henter referencer...",
      error: "Der opstod en fejl ved hentning af referencer",
      empty: "Ingen referencer fundet i øjeblikket.",
      spec_rider: "Rytter",
      spec_achievement: "Resultat"
    },
    sponsors: {
      badge: "Samarbejde",
      title: "Sponsorer &",
      title_italic: "partnere",
      desc: "Vi samarbejder stolt med nogle af verdens førende brands inden for ridesporten. Deres opbakning sikrer, at vores heste og ryttere altid har adgang til det absolut bedste udstyr og de bedste faciliteter.",
      loading: "Henter sponsorer...",
      error: "Der opstod en fejl ved hentning af sponsorer",
      partner_title: "Bliv Partner hos Equinesport",
      partner_desc: "Siden opdateres løbende med nye sponsorer, logoer og links. Ønsker du at indgå et eksklusivt partnerskab med Marcus & Rikke Heineking? Kontakt os i dag for at høre om mulighederne.",
      partner_btn: "Kontakt os angående sponsorat"
    },
    about: {
      badge: "Om Os",
      title: "Decades of Elite",
      title_italic: "Equestrian Excellence",
      paragraphs: [
        "Equinesport blev etableret i 2012 og drives af Rikke og Marcus Heineking.",
        "Vi arbejder hver dag meget fokuseret på at udvide vores forretning i Danmark og i udlandet. Vi er også dybt engagerede i konkurrencer både i indlandet og på den internationale arena.",
        "Vi sætter stor pris på at give hestene og vores kunder en positiv oplevelse under de bedst mulige forhold.",
        "Træningen af ​​de enkelte heste planlægges efter deres konkurrenceniveau i forhold til deres alder.",
        "Gennem årene har vi opnået mange gode resultater med sejre i unghesteklasser, verdensmesterskaber for unge heste, medaljer ved danmarksmesterskaberne, Nation Cups, Grand Prix-sejre og 5* Grand Prix-placeringer.",
        "Sammen med vores fantastiske personale arbejder vi alle sammen hver dag for at nå vores mål!",
        "Med planlagt træning samt daglig pleje af hestene. Det inkluderer:",
        "• individuel træning for hver enkel hest",
        "• daglig pleje",
        "• Walker og græs folde",
        "• kvalitets foder og strøelse",
        "Derudover bruger vi kvalificeret dyrlæger og fagudlærte beslagsmede.",
        "I vores team er hestens velbefindende altid i fokus.",
        "De erfaringer, der driver vores stald, er bygget på vores viden og værdier indsamlet gennem mange år i sporten."
      ],
      founders_badge: "Grundlæggere",
      founders_title: "Vores Ledelse",
      profiles: [
        {
          name: "Marcus Heineking",
          role: "Co founder og Elite træner",
          bio: "International Grand Prix-rytter med adskillige sejre og placeringer på højeste niveau i springsporten. Marcus er anerkendt for sin enestående evne til at uddanne unge heste hele vejen op til internationalt Grand Prix-niveau."
        },
        {
          name: "Rikke Heineking",
          role: "Co founder og Elite rytter",
          bio: "Professionel rytter og træner med en dyb passion for hestevelfærd og dressurarbejde. Rikke leder den daglige drift, træningsprogrammerne og sikrer, at hver hest modtager individuel pleje i verdensklasse."
        }
      ]
    },
    gallery: {
      badge: "Mediearkiv",
      title: "Galleri &",
      title_italic: "medier",
      desc: "Oplev vores heste, træningsfaciliteter og hverdagen hos Equinesport i billeder. Klik på et billede for at åbne det i stor visning.",
      loading: "Henter gallerier...",
      error: "Der opstod en fejl ved hentning af gallerier",
      empty: "Ingen gallerier fundet i øjeblikket.",
      empty_album: "Der er i øjeblikket ingen billeder i dette album. Nye billeder tilføjes snarest."
    },
    contact: {
      badge: "Kontakt",
      title: "Indled en",
      title_italic: "fortrolig",
      title_suffix: "Dialog",
      desc: "Uanset om du søger en specifik sportshest, ønsker at sælge, eller vil høre mere om vores træningsprogrammer, står vi klar til at rådgive dig på højeste professionelle niveau.",
      form_title: "Send os en besked",
      form_name: "Navn",
      form_name_placeholder: "Dit fulde navn",
      form_phone: "Telefonnummer",
      form_phone_placeholder: "F.eks. +45 52 17 49 97",
      form_email: "E-mail",
      form_email_placeholder: "din@email.com",
      form_desc: "Beskrivelse",
      form_desc_placeholder: "Beskriv dine ønsker eller forespørgsel...",
      form_files: "Vedhæft filer (valgfrit)",
      form_files_placeholder: "Klik eller træk filer hertil",
      form_files_sub: "PDF, PNG, JPEG, GIF, WEBP (Max 10 MB pr. fil, maks 5 filer)",
      form_files_remove: "Fjern",
      form_btn_send: "Send Forespørgsel",
      form_btn_sending: "Sender...",
      form_error_required: "Udfyld venligst alle påkrævede felter.",
      form_error_files_limit: "Du kan maksimalt vedhæfte 5 filer i alt.",
      form_error_file_type: "Filtypen er ikke tilladt. Tilladte typer: PDF, PNG, JPEG, GIF, WEBP.",
      form_error_file_size: "Filen overskrider grænsen på 10 MB.",
      form_success: "Tak for din henvendelse. Vi vender tilbage til dig hurtigst muligt.",
      sidebar_title: "Kontaktpersoner",
      sidebar_direct: "Direkte Kontakt",
      sidebar_phone: "Telefon",
      sidebar_email: "E-mail"
    }
  },
  en: {
    meta: {
      home: {
        title: "Exclusive Sport Horses | Equinesport Heineking",
        description: "Education, training, and sales of exclusive sport horses in the absolute highest international price segment. Established in 2012 by Marcus & Rikke Heineking."
      },
      horses_sales: {
        title: "Horses for Sale | Exclusive Collection | Equinesport",
        description: "See our selected collection of exclusive show jumping horses for sale in the absolute top sport segment. Prices around 1 million euros each."
      },
      horses_sport: {
        title: "Elite Sport Horses | International Top Class | Equinesport",
        description: "Explore our elite sport horses trained to the highest international level. Uncompromising quality and documented results."
      },
      references: {
        title: "References & Results | Equinesport",
        description: "See our successful references and horses performing on the largest international arenas under the world's elite."
      },
      sponsors: {
        title: "Sponsors & Partners | Equinesport",
        description: "Our strong network of leading global brands and partners in equestrian sports, sharing our passion for perfection."
      },
      about: {
        title: "About Us | Decades of Elite Equestrian Excellence | Equinesport",
        description: "Learn more about Equinesport, founded in 2012 by Grand Prix rider Marcus Heineking and elite trainer Rikke Heineking."
      },
      gallery: {
        title: "Gallery & Media | Equinesport",
        description: "Experience our horses, training facilities, and daily life at Equinesport in pictures. View our exclusive media archive."
      },
      contact: {
        title: "Contact Us | Initiate a Confidential Dialogue | Equinesport",
        description: "Contact Marcus & Rikke Heineking for a confidential conversation about buying, selling, or training elite sport horses."
      }
    },
    nav: {
      home: "Home",
      horses: "Horses",
      horses_sales: "Sales",
      horses_sport: "Sport Horses",
      references: "References",
      sponsors: "Sponsors",
      about: "About Us",
      gallery: "Gallery",
      contact: "Contact"
    },
    home: {
      hero_badge: "Est. 2012",
      hero_title_italic: "",
      hero_title_main: "Equinesport",
      hero_desc: "",
      hero_btn_collection: "See the Collection",
      hero_btn_contact: "Initiate Dialogue",
      
      about_title: "Education & individual training",
      about_desc: "At Equinesport, every single sport horse is unique. Since 2012, we have specialized in identifying, educating, and refining horses with potential for absolute top-level sport. Our average price segment of approximately 1 million euros per horse reflects the uncompromising quality and meticulous work put into every single detail.",
      about_btn: "Read more about our philosophy",
      
      focus_badge: "Explore Our World",
      focus_title: "Strategic Focus Areas",
      focus_desc: "Click on the boxes below to dive deeper into our core competencies and exclusive services.",
      
      box1_badge: "Exclusive Portfolio",
      box1_title: "Collection & Sales",
      box1_desc: "Discover our carefully selected collection of international sport horses in the absolute highest price segment.",
      box1_btn: "See the Collection",
      
      box2_badge: "Uncompromising Refinement",
      box2_title: "About Us",
      box2_desc: "Tailored training programs for horse and rider aimed at absolute top-level sport.",
      box2_btn: "Read About Training",
      
      box3_badge: "Documented Success",
      box3_title: "References & Results",
      box3_desc: "Our horses perform on the largest international arenas under riders in the absolute world elite.",
      box3_btn: "A selection of horses sold through the years",
      
      box4_badge: "Strong Network",
      box4_title: "Sponsors & Partners",
      box4_desc: "Close cooperation with leading global brands and partners who share our passion for perfection.",
      box4_btn: "See Our Partners",
      
      expertise_badge: "Our Expertise",
      expertise_title: "Strategic Focus Areas",
      
      banner_title: "Investment in Performance & Genetics",
      banner_desc: "Marcus and Rikke Heineking ensure through personal selection and uncompromising education that every single horse possesses the necessary capacity, caution, and rideability to perform on the global stage.",
      banner_stat1_label: "Individual Focus",
      banner_stat2_label: "Level",
      banner_stat3_label: "Established",
      invitation_text: "Feel free to look around our homepage, and don't hesitate to contact us!"
    },
    horses: {
      badge: "Collection",
      title_sales: "Sales",
      title_sport: "Sport Horses",
      title_suffix: "Collection",
      desc_sales: "Selected horses for sale in the absolute top sport segment",
      desc_sport: "Exclusive sport horses trained to the highest international level",
      desc_suffix: "Each horse in our collection is carefully selected, health-tested, and trained for optimal performance and durability.",
      loading: "Loading horses from CMS...",
      error: "An error occurred while loading horses",
      empty: "No horses found in this category at the moment.",
      spec_pedigree: "Pedigree",
      spec_gender: "Gender",
      spec_age: "Age",
      spec_height: "Height",
      age_suffix: "years",
      btn_inquiry: "Inquiry",
      btn_call: "Call Marcus"
    },
    references: {
      badge: "Success Stories",
      title: "References &",
      title_italic: "stories",
      desc: "Our greatest pride is the horses we have sold and trained, which are now performing at the highest international level with their new riders worldwide.",
      loading: "Loading references...",
      error: "An error occurred while loading references",
      empty: "No references found at the moment.",
      spec_rider: "Rider",
      spec_achievement: "Achievement"
    },
    sponsors: {
      badge: "Collaboration",
      title: "Sponsors &",
      title_italic: "partners",
      desc: "We proudly collaborate with some of the world's leading brands in equestrian sports. Their support ensures that our horses and riders always have access to the absolute best equipment and facilities.",
      loading: "Loading sponsors...",
      error: "An error occurred while loading sponsors",
      partner_title: "Become a Partner at Equinesport",
      partner_desc: "This page is continuously updated with new sponsors, logos, and links. Would you like to enter into an exclusive partnership with Marcus & Rikke Heineking? Contact us today to hear about the opportunities.",
      partner_btn: "Contact us regarding sponsorship"
    },
    about: {
      badge: "About Us",
      title: "Decades of Elite",
      title_italic: "Equestrian Excellence",
      paragraphs: [
        "Equinesport was established in 2012 and is run by Rikke and Marcus Heineking.",
        "We are everyday working very focused in expanding our business in Denmark and abroad. We are also deeply engaged in competitions both inland and on the international arena.",
        "We value very much to give the horses and our customers a positive experience under the best possible conditions.",
        "The training of the individual horses is planned according to their level of competition for their age.",
        "Over the years we made a lot of good results from winning young horse classes, world championship for young horses, medals at the danish championships, Nation Cups, Grand Prix wins and 5* Grand Prix placings.",
        "Together with our great staff, we are all working together everyday to reach our goals!",
        "With planned training as well as daily care of the horses. That includes:",
        "• individual training for each horse",
        "• daily care",
        "• walker and grass paddocks",
        "• quality feed and bedding",
        "In addition, we use qualified veterinarians and certified farriers.",
        "In our team, horses well being is always in focus.",
        "The experiences that drive our stable are build on our knowledge and values gathered through years in the sport."
      ],
      founders_badge: "Founders",
      founders_title: "Our Leadership",
      profiles: [
        {
          name: "Marcus Heineking",
          role: "Co-founder & Elite Trainer",
          bio: "International Grand Prix rider with numerous victories and placings at the highest levels of show jumping. Marcus is renowned for his exceptional ability to educate young horses up to international Grand Prix level."
        },
        {
          name: "Rikke Heineking",
          role: "Co-founder & Elite Rider",
          bio: "Professional equestrian and trainer with a deep passion for horse welfare and flatwork. Rikke manages the daily operations, training programs, and ensures every horse receives individual, world-class care."
        }
      ]
    },
    gallery: {
      badge: "Media Archive",
      title: "Gallery &",
      title_italic: "media",
      desc: "Experience our horses, training facilities, and daily life at Equinesport in pictures. Click on an image to open it in a large view.",
      loading: "Loading galleries...",
      error: "An error occurred while loading galleries",
      empty: "No galleries found at the moment.",
      empty_album: "There are currently no photos in this album. New photos will be added soon."
    },
    contact: {
      badge: "Contact",
      title: "Initiate a",
      title_italic: "confidential",
      title_suffix: "Dialogue",
      desc: "Whether you are looking for a specific sport horse, wish to sell, or want to hear more about our training programs, we are ready to advise you at the highest professional level.",
      form_title: "Send us a message",
      form_name: "Name",
      form_name_placeholder: "Your full name",
      form_phone: "Phone Number",
      form_phone_placeholder: "E.g. +45 52 17 49 97",
      form_email: "Email",
      form_email_placeholder: "your@email.com",
      form_desc: "Description",
      form_desc_placeholder: "Describe your wishes or inquiry...",
      form_files: "Attach files (optional)",
      form_files_placeholder: "Click or drag files here",
      form_files_sub: "PDF, PNG, JPEG, GIF, WEBP (Max 10 MB per file, max 5 files)",
      form_files_remove: "Remove",
      form_btn_send: "Send Inquiry",
      form_btn_sending: "Sending...",
      form_error_required: "Please fill in all required fields.",
      form_error_files_limit: "You can attach a maximum of 5 files in total.",
      form_error_file_type: "File type is not allowed. Allowed types: PDF, PNG, JPEG, GIF, WEBP.",
      form_error_file_size: "The file exceeds the 10 MB limit.",
      form_success: "Thank you for your inquiry. We will get back to you as soon as possible.",
      sidebar_title: "Contact Persons",
      sidebar_direct: "Direct Contact",
      sidebar_phone: "Phone",
      sidebar_email: "Email"
    }
  }
};

export const FOCUS_WORDS_TRANSLATED = {
  da: [
    { text: "Køb af heste", description: "Erhvervelse af elite-emner" },
    { text: "Salg af heste", description: "Globalt salgsnetværk" },
    { text: "Uddannelse", description: "Uddannelse i verdensklasse" },
    { text: "Individuel træning", description: "Skræddersyet atletisk udvikling" },
    { text: "Siden 2012", description: "Over et årti med topkvalitet" }
  ],
  en: [
    { text: "Horse Acquisition", description: "Acquisition of elite prospects" },
    { text: "Horse Sales", description: "Global sales network" },
    { text: "Education", description: "World-class education" },
    { text: "Individual Training", description: "Tailored athletic development" },
    { text: "Since 2012", description: "Over a decade of excellence" }
  ]
};
